import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core';
import {XploreItemService} from "../../../services/xplore-item.service";
import {SimpleXploreItemDTO, XploreItemDTO} from "../../../shared/object/xplorer-be-parsed-classes";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import { TranslateModule } from '@ngx-translate/core';
import { PreviewItemCardComponent } from '../preview-item-card/preview-item-card.component';


@Component({
    selector: 'app-related-items-manager',
    templateUrl: './related-items-manager.component.html',
    styleUrls: ['./related-items-manager.component.css'],
    imports: [PreviewItemCardComponent, TranslateModule]
})
export class RelatedItemsManagerComponent implements OnChanges, OnDestroy {

  @Input()
  xploreItemId: number;

  @Input()
  isShowed: boolean;

  relatedXploreItems: SimpleXploreItemDTO[] = [];
  destroyed$ = new Subject<void>();

  isLoadingRelatedItems = false;

  private xploreItemService: XploreItemService = inject(XploreItemService);


  ngOnChanges(changes: SimpleChanges): void {
    if(changes['isShowed'].currentValue && this.relatedXploreItems.length === 0) {
      this.isLoadingRelatedItems = true;
      this.xploreItemService.getNearbySimpleXploreItems(this.xploreItemId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
        (response) => {
          this.isLoadingRelatedItems = false;
          this.relatedXploreItems = response;
        }
      )
    }
  }


  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
